import { DocumentService } from '@fi-app/document/document.service';

export const FiDocumentStatesResolveDefaultTemplateSettings = [
    DocumentService,
    FiDocumentStatesResolveDefaultTemplateSettingsResolveFunc,
];

export function FiDocumentStatesResolveDefaultTemplateSettingsResolveFunc(documentService: DocumentService) {
    return documentService.GetDefaultTemplate();
}
